module.exports = __webpack_public_path__ + "static/logo-8b398c4140167122288c76c1d83ebee1.png";